export const Heading = {
  baseStyle: {
    fontFamily: 'Mont-Heavy',
    fontWeight: 800,
  },
};
